import React from "react";
import { MdOutlineContactPhone, MdAlternateEmail } from "react-icons/md";
import companyLocation from './../image/3.png'; // Add your company logo path
import companyLocation1 from './../image/2.png'; // Add your company logo path
import backgroundimg from "./../image/contactbanner.png";

const GetInTouch = () => {
  return (
    <div
  className="bg-gradient-to-l from-white to-[#d3e4f1] p-8 w-full max-w-[1320px] object-contain shadow-lg rounded-lg mb-10 mt-10 bg-blend-overlay bg-cover bg-center"
  style={{ backgroundImage: `url(${backgroundimg})`,objectFit:'fill' }}
>

      
      {/* Top Section */}
      <div className="flex flex-col md:flex-row justify-between gap-2 border-b pb-8">
        {/* Left Side */}
        <div className="flex-1 max-w-[600px]">
          <h3 className="text-3xl font-[700] text-white uppercase tracking-wide">
            Our Offices
          </h3>
          <div className="mt-6 text-white text-center md:text-left">
            <p className="text-[16px] font-normal">
            Feel free to visit any of our offices for assistance. Our team is always ready to help you with your needs, ensuring exceptional service at every location.
            </p>
          </div>
        </div>

        {/* Right Side - Office Addresses */}
        <div className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* USA Address */}
          <div className="flex items-start bg-gradient-to-l from-white to-[#d3e4f1] gap-3 p-2 border rounded-lg hover:shadow-md transition-all duration-300">
            <div className="text-[#005eb8]">
              <img src={companyLocation} alt="Company Location" className="w-28" />
            </div>
            <div>
              <h2 className="font-semibold text-lg text-gray-800">USA</h2>
              <p className="text-[14px] text-gray-600">
                1600 Heritage Landing Suite # G212,
                <br />
                Saint Peters, Missouri 63303,
                <br />
                United States
              </p>
            </div>
          </div>

          {/* UK Address */}
          <div className="flex items-start bg-gradient-to-l from-white to-[#d3e4f1] gap-3 p-2 border rounded-lg hover:shadow-md transition-all duration-300">
            <div className="text-[#005eb8]">
              <img src={companyLocation1} alt="Company Location" className="w-20" />
            </div>
            <div>
              <h2 className="font-semibold text-lg text-gray-800">UK</h2>
              <p className="text-[14px] text-gray-600">
                381 Midsummer Blvd,
                <br />
                Milton Keynes MK9 3HP,
                <br />
                United Kingdom
              </p>
            </div>
          </div>

          {/* India Address */}
          {/* <div className="flex items-start bg-gradient-to-l from-white to-[#d3e4f1] gap-3 p-2 border rounded-lg hover:shadow-md transition-all duration-300">
            <div className="text-[#005eb8]">
              <img src={companyLocation2} alt="Company Location" className="w-28" />
            </div>
            <div>
              <h2 className="font-semibold text-lg text-gray-800">India</h2>
              <p className="text-[14px] text-gray-600">
                Flat No. 604, Annapurna Block,
                <br />
                Aditya Enclave, Ameerpet,
                <br />
                Hyderabad - 500016, Telangana, India.
              </p>
            </div>
          </div> */}
        </div>
      </div>

      {/* Bottom Section */}
      <div className="flex flex-col md:flex-row justify-between gap-8 mt-8">
        {/* Left Side */}
        <div className="flex-1">
          <h3 className="text-3xl font-[700] text-white uppercase tracking-wide">
            Get in Touch
          </h3>
          <p className="text-white mt-2 text-[16px]">
            Feel free to contact us anytime. Our team is happy to help!
          </p>
        </div>

        {/* Right Side - Contact Info */}
        <div className="flex-1 grid grid-cols-1  md:grid-cols-2 gap-6">
          {/* Phone */}
          <div className="flex items-start bg-gradient-to-l from-white to-[#d3e4f1] gap-3 p-4 border rounded-lg hover:shadow-md transition-all duration-300">
            <div className="text-[#005eb8] p-2">
              <MdOutlineContactPhone className="text-3xl" />
            </div>
            <div>
              <h2 className="font-semibold text-lg text-gray-800">Call Us</h2>
              <p className="text-[14px] text-gray-600">+1 732-612-9958</p>
            </div>
          </div>

          {/* Email */}
          <div className="flex items-start gap-3 p-4 bg-gradient-to-l from-white to-[#d3e4f1] border rounded-lg hover:shadow-md transition-all duration-300">
            <div className="text-[#005eb8] p-2">
              <MdAlternateEmail className="text-3xl" />
            </div>
            <div>
              <h2 className="font-semibold text-lg text-gray-800">Email Us</h2>
              <p className="text-[14px] text-gray-600">info@nexifyinfosystems.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
